<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <template slot="field">
      <vue-tel-input
        v-model="fieldValue"
        :input-id="field.attribute"
        :class="errorClasses"
        :placeholder="inputPlaceholder"
        :disabled="isDisabled"
        :preferred-countries="[
          'be',
          'nl',
          'fr',
          'gb',
          'ie',
          'us',
          'de',
          'es',
          'it',
        ]"
        :input-options="{ showDialCode: true }"
        :valid-characters-only="true"
        input-classes="form-control"
      />
    </template>
  </component>
</template>

<script>
import { FormTextField } from 'stylemix-base'
import { VueTelInput } from 'vue-tel-input'

export default {
  name: 'PhoneField',

  components: { VueTelInput },

  extends: FormTextField,
}
</script>
